// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";

function useAccordion(param) {
  var match = React.useState(function () {
        return 1;
      });
  var setIndex = match[1];
  var _index = match[0];
  var isActive = function (index) {
    return index === _index;
  };
  var accordionOnClick = function (index) {
    return Curry._1(setIndex, (function (param) {
                  if (index === _index) {
                    return 1;
                  } else {
                    return index;
                  }
                }));
  };
  return [
          isActive,
          accordionOnClick
        ];
}

export {
  useAccordion ,
  
}
/* react Not a pure module */
